import React from 'react';
import { NavLink } from 'react-router-dom';
import { currentUserHasCerebralAdminRole, getCurrentUser } from '../../utils/roleCheck';

function UserHomeSidebar({ isOpen, isMobile, onClose, onToggle }) {
  const isCerebralAdmin = currentUserHasCerebralAdminRole();
  const currentUser = getCurrentUser();
  const isAwarenessUser = currentUser?.email === 'hpatelecom@yahoo3.com';

  const navGroups = [
    {
      category: 'Build',
      items: [
        {
          path: '/user-home/workspaces',
          label: 'Workspaces',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          ),
        },
        {
          path: '/user-home/graphs',
          label: 'Graphs',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="20" x2="18" y2="10"></line>
              <line x1="12" y1="20" x2="12" y2="4"></line>
              <line x1="6" y1="20" x2="6" y2="14"></line>
            </svg>
          ),
        },
        {
          path: '/user-home/lookup',
          label: 'Lookup',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          ),
        },
        {
          path: '/user-home/process-maps',
          label: 'Process Maps',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="16 3 21 3 21 8"></polyline>
              <line x1="4" y1="20" x2="21" y2="3"></line>
              <polyline points="21 16 21 21 16 21"></polyline>
              <line x1="15" y1="15" x2="21" y2="21"></line>
              <line x1="4" y1="4" x2="9" y2="9"></line>
            </svg>
          ),
        },
        {
          path: '/user-home/chat-assistant',
          label: 'Chat Assistant',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
          ),
        },
        {
          path: '/user-home/ednl',
          label: 'EDNL',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          ),
        },
        ...(isCerebralAdmin ? [{
          path: '/user-home/admin/packs',
          label: 'Category Packs',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
          ),
        }] : []),
      ],
    },
    {
      category: 'Connect',
      items: [
        {
          path: '/user-home/integrations',
          label: 'Integrations',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M12 1v6m0 6v6m5.196-14.196l-4.242 4.242m-5.908 5.908l-4.242 4.242m14.196-4.242l-4.242-4.242m-5.908-5.908l-4.242-4.242"></path>
            </svg>
          ),
        },
        {
          path: '/user-home/admin/mcp-servers',
          label: 'MCP Servers',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
              <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
              <line x1="6" y1="6" x2="6.01" y2="6"></line>
              <line x1="6" y1="18" x2="6.01" y2="18"></line>
            </svg>
          ),
        },
        {
          path: '/user-home/admin/secrets',
          label: 'Workspace Secrets',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          ),
        },
      ],
    },
    {
      category: 'Authorization',
      items: [
        {
          path: '/user-home/account-management',
          label: 'Account Management',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          ),
        },
        {
          path: '/user-home/user-management',
          label: 'User Management',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="20" y1="8" x2="20" y2="14"></line>
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
          ),
        },
      ],
    },
    {
      category: 'Billing',
      items: [
        ...(isCerebralAdmin ? [{
          path: '/user-home/admin/billing',
          label: 'Billing & Usage',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="5" width="20" height="14" rx="2"></rect>
              <line x1="2" y1="10" x2="22" y2="10"></line>
            </svg>
          ),
        }] : []),
        {
          path: '/user-home/subscription',
          label: 'Subscription',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
          ),
        },
        ...(isCerebralAdmin ? [{
          path: '/user-home/admin/billing/invoices',
          label: 'Invoices',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
            </svg>
          ),
        }] : []),
        ...(isCerebralAdmin ? [{
          path: '/user-home/admin/billing/pricing-plans',
          label: 'Pricing Plans',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 12V8H6a2 2 0 0 1 0-4h12v4"></path>
              <path d="M4 6v12c0 1.1.9 2 2 2h14v-4"></path>
              <path d="M18 12a2 2 0 0 0 0 4h4v-4z"></path>
            </svg>
          ),
        }] : []),
        ...(isCerebralAdmin ? [{
          path: '/user-home/admin/billing/onboard',
          label: 'Onboard Customer',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
              <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
              <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
              <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
            </svg>
          ),
        }] : []),
      ],
    },
    {
      category: 'System',
      items: [
        {
          path: '/user-home/settings',
          label: 'Settings',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M12 1v6m0 6v6m5.196-14.196l-4.242 4.242m-5.908 5.908l-4.242 4.242M5.196 5.196l4.242 4.242m5.908 5.908l4.242 4.242"></path>
            </svg>
          ),
        },
      ],
    },
    ...(isAwarenessUser ? [{
      category: 'Awareness',
      items: [
        {
          path: '/user-home/lead-management',
          label: 'Leads',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          ),
        },
        {
          path: '/cdi-demo',
          label: 'CDI Demo',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
          ),
        },
        {
          path: '/user-home/lead-magnet-management',
          label: 'Lead Magnets',
          icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
          ),
        },
      ],
    }] : []),
  ];

  const handleNavClick = () => {
    if (isMobile) {
      onClose();
    }
  };

  return (
    <>
      <aside className={`user-home-layout__sidebar ${isOpen ? 'open' : ''} ${isMobile ? 'mobile' : ''}`}>
        {!isMobile && (
          <button
            className="user-home-layout__sidebar-toggle"
            onClick={onToggle}
            aria-label="Collapse sidebar"
            title="Collapse sidebar"
          >
            &laquo;
          </button>
        )}
        <nav className="user-home-layout__nav">
          {navGroups.filter(g => g.items.length > 0).map((group) => (
            <React.Fragment key={group.category}>
              <div className="user-home-layout__nav-category">{group.category}</div>
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) =>
                    `user-home-layout__nav-item ${isActive ? 'active' : ''}`
                  }
                  onClick={handleNavClick}
                >
                  <span className="user-home-layout__nav-icon">{item.icon}</span>
                  <span className="user-home-layout__nav-label">{item.label}</span>
                </NavLink>
              ))}
            </React.Fragment>
          ))}
        </nav>
      </aside>
      {!isMobile && !isOpen && (
        <button
          className="user-home-layout__sidebar-expand"
          onClick={onToggle}
          aria-label="Expand sidebar"
          title="Expand sidebar"
        >
          &raquo;
        </button>
      )}
    </>
  );
}

export default UserHomeSidebar;
